// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1u1Nw","boxTitle":"Qualiphy_boxTitle__14XwP","box":"Qualiphy_box__1oWFg","toggleWrap":"Qualiphy_toggleWrap__1jfm-"};